import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'semantic-ui-react'
import { styledWithProp } from 'hoc/styledWithProp'

export const ButtonGroup = ({ children, buttonStyle, buttonClassName, bold, ...props }) => {
  const ButtonGroupComponent = bold ? BoldButtonGroups : Button.Group
  return (
    <ButtonGroupComponent basic {...props}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { style: buttonStyle, className: buttonClassName })
      )}
    </ButtonGroupComponent>
  )
}

ButtonGroup.Button = Button

ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  buttonStyle: PropTypes.object,
  buttonClassName: PropTypes.string,
  bold: PropTypes.bool,
}

const BoldButtonGroups = styledWithProp(ButtonGroup, 'buttonClassName')`
  &&&& {
    font-weight: bold;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ButtonGroup/index.js